import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/analytics'
import { environment } from '../environments/environment';

firebase.initializeApp(environment.firebase);
export default firebase;
